import {
  createNewPageAndUpdateRoute,
  updatePageRoute,
} from '@/utilities/createNewPageAndUpdateRoute';
import { generateEditorId } from '@/utilities/generateEditorId';
import { ResourceType } from '@/types/resources';

export default {
  methods: {
    createPageAndUpdateRoute(noContent = false) {
      return createNewPageAndUpdateRoute(this.page, noContent);
    },
    updateRoute(page) {
      updatePageRoute(page);
    },
    checkNewPage() {
      if (this.$route.name === 'newpage' && !this.pageCreating) {
        this.createPageAndUpdateRoute().then((page) => {
          this.$store.dispatch('setPageUploadPopup', {
            ...(this.$store.getters.getPageUploadPopup || {}),
            editorId: generateEditorId(ResourceType.Page, page.id, this.$store.getters.getTeamID),
          });
          this.uploadPageImage();
        });
        return;
      }
      this.uploadPageImage();
    },
  },
  computed: {
    page() {
      return this.$store.getters.getPage;
    },
    pageCreating() {
      return this.$store.getters.pageCreating;
    },
  },
};
